import React from 'react';
import { Helmet } from 'react-helmet';
import { isMobileOnly } from 'react-device-detect';
import { isPortraitTablet } from '../../../app';
import { BackLink } from '../../../common/elements/back-link/back-link';
import { PictureBlock } from '../../../common/elements/picture-block/picture-block';
import { ContentBlock } from '../../../common/elements/content-block/content-block';
import { Title } from '../../../common/elements/title/title';
import { ScrollToTop } from '../../../common/scripts/scroll-to-top';
import { Paragraph } from '../../../common/elements/paragraph/paragraph';
import { ExternalLink } from '../../../common/elements/external-link/external-link';

import css from '../massage.module.scss';

import jorgeImg from '../../../common/assets/masseur-jorge-big.jpg';

export const Jorge = () => {
    return (
        <ScrollToTop>
            <Helmet>
                <title>
                    Masseur Harald | Massage | Nieuwezijds Gay sauna Amsterdam
                </title>
                <meta
                    name="description"
                    content="Information about Robert, one of the masseurs available in the Nieuwezijds Gay Sauna in Amsterdam."
                />
            </Helmet>
            <section className={css.root}>
                <PictureBlock showPicture imageSrc={jorgeImg} />
                <ContentBlock position="2">
                    {(isMobileOnly || isPortraitTablet) && (
                        <BackLink href="/massage" text="massage" />
                    )}
                    <Title as="h1" text="Jorge" />
                    <Paragraph>
                        With his background as dancer and actor Jorge has always
                        been deeply connected with the body possibilities.
                    </Paragraph>
                    <Paragraph>
                        As a certified massage therapist he offers a relaxing
                        experience through the healing effect of the conscious
                        sensitive touch.
                    </Paragraph>

                    <Paragraph>
                        Trained in classic relaxation massage and Thai massage
                        he has developed his own signature style focused on your
                        wellbeing, from soft to more deep tissue techniques
                        creates the perfect space for deep relaxation and
                        renewal for body and mind!
                    </Paragraph>

                    <Paragraph>
                        book a session at the bar or call in advance to make a
                        reservation:
                        <br />
                        <ExternalLink
                            className={css.big}
                            href="tel:31203318327"
                            text="+31 20 331 8327"
                        />
                    </Paragraph>
                </ContentBlock>
            </section>
        </ScrollToTop>
    );
};
